export default {
  path: 'aggregator/approvals/:id',
  name: 'Aggregator_approvals_details',
  meta: {
    parent_vue_name: 'Aggregator_approvals',
    breadcrumb_value: 'road-maintenance.approvals',
    open_tab: 'approval',
    redirectViewName: 'Aggregator_approvals'
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../../common/views/AggregatorDetails.vue')
}
